module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp23_4.768e34d4.png";